var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 453,
    viewBox: "0 0 1440 453",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2114.48 443.943C924.586 443.943 -40.0201 249.11 -40.0201 8.75523L-88 465H4221V0C4221 240.355 3304.37 443.943 2114.48 443.943Z",
    fill: "#8DC641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVector);
export default __webpack_public_path__ + "static/media/green-vector.62a151e3d2be4abd0711366d0d6dc31b.svg";
export { ForwardRef as ReactComponent };